import React, { useContext, useEffect, useState } from 'react'

import { AuthContext } from '../../context/AuthContext';
import ENDPOINT from '../../context/EndPoint';
import HackingInternshipRegistrationItem from './HackingInternshipRegistrationItem';
import Localbase from 'localbase';
import { set } from 'firebase/database';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useActionsContext } from '../../context/ActionsContext';

const HackingInternshipRegistrations = () => {
 const dispatch = useDispatch()
  let db= new Localbase('db')
  const {user} = useContext(AuthContext);

   
  const [toast,setToast]= useState(false)
  const [message,setMessage] = useState("")
  const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
  
 
  
  // Sample array of user IDs
  const users = [];
  
   const [registrations,setRegistrations] = useState(null)

   const getRegistrations = async ()=>{
    dispatch({type:'LOADING'})   
    const data = new FormData()
    data.append('session', user.SessionId)
    data.append('limit', rowsPerPage)
   try{
 const result = await axios.post(`${ENDPOINT}admin-get-hacking-internship-registrations.php`,data,SecurityHeaders)
 if(result.data) {
   dispatch({type:'DONE_LOADING'})
  setRegistrations(result.data.data);
  setInititalData(result.data.data)
  setResponse(result.data.data)
  const data = result.data.data;
  db.collection('paths').doc("hacking_internship").set({data})
      .then(() => {
          console.log("Document successfully written!");
      })
      .catch(error => {
          console.error("Error writing document: ", error);
      });
      

 
// Sample array of user IDs   
result.data.data.map((item)=>(
users.push(item.id)
))
 }


   }
   catch(error){
    console.log(error);
    dispatch({type:'ERROR',payload:error.message});

   }

   }
   useEffect(()=>{
    db.collection('paths').doc('hacking_internship').get().then((data)=>{
      setRegistrations(data.data);
      setInititalData(data.data)
      setResponse(data.data)
    })
   },[])
   useEffect(() => {
 

       getRegistrations()
    
   }, [rowsPerPage])

   const [sendMessage, setSendMessage] = useState('');
 
 // Load the saved message from local storage when the component mounts

 // Update the message state when the input field value changes
 const handleChange = (e) => {
   setSendMessage(e.target.value);
 };
 
 // Save the message to local storage
 const saveMessageToLocalStorage = () => {
   localStorage.setItem('wa_message', sendMessage);
 };

 const [initialData,setInititalData] = useState(null)
 
 const [response, setResponse] = useState(initialData);
 const [searchTerm, setSearchTerm] = useState('');

 const handleSearch = (e) => {
   const term = e.target.value.toLowerCase();

   const filteredData = initialData.filter((item) => {
     return (
       item.email.toLowerCase().includes(term) ||      
       item.name.toLowerCase().includes(term)
     );
   });

   setResponse(filteredData);
   setSearchTerm(term);
 };

 const [selecteditems,setselecteditems] = useState([])
 useEffect(()=>{
    // console.log(selecteditems)
 },[selecteditems])
  const [visibility,setvisibility] = useState(false)

  const [selectedData, setSelectedData] = useState([]);

  // Function to handle user click
  const handleUserClick = (id) => {
    // Check if the user ID is already in the selectedData array
    const isSelected = selectedData.includes(id);

    // If selected, remove from the array; otherwise, add to the array
    setSelectedData((prevSelectedData) => (
      isSelected
        ? prevSelectedData.filter(uid => uid !== id)
        : [...prevSelectedData, id]
    ));

     // console.log(selectedData)
  };

  const [edit,setedit] = useState(false)

  const CloseEdit = ()=>{

setedit(false)

  }

  const [selectedusers,setselectedusers] = useState([])


  const SelectUser = ({id})=>{

if(selectedusers.includes(id)){

  var index = selectedusers.indexOf(id)
  selectedusers.splice(index,1)
}else{
  selectedusers.push(id)

}
 // console.log(selectedusers)

  }
  return (
   <>










   <div className="container-fluid">
          
          <div className="row">
            <div className="col-lg-12">
              <div className="card" id="orderList">
                <div className="card-header border-0">
                  <div className="row align-items-center gy-3">
                    <div className="col-sm">
                      <h5 className="card-title mb-0">Ethical Hacking Internship Registrations</h5>
                    </div>
                    <div className="col-sm-auto">
                      <div className="d-flex gap-1 flex-wrap">
                        <button
                          type="button"
                          className="btn btn-success add-btn"
                          data-bs-toggle="modal"
                          id="create-btn"
                          data-bs-target="#showModal"
                        >
                          <i className="ri-add-line align-bottom me-1" /> Create
                          Order
                        </button>
                        <button type="button" className="btn btn-info">
                          <i className="ri-file-download-line align-bottom me-1" />{" "}
                          Import
                        </button>
                        <button
                          className="btn btn-soft-danger"
                          id="remove-actions"
                          onclick="deleteMultiple()"
                        >
                          <i className="ri-delete-bin-2-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body border border-dashed border-end-0 border-start-0">
                  <form>
                    <div className="row g-3">
                      <div className="col-xxl-5 col-sm-6">
                        <div className="search-box">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search for username, email or phone number..."
                          />
                          <i className="ri-search-line search-icon" />
                        </div>
                      </div>
                      {/*end col*/}
                      <div className="col-xxl-2 col-sm-6">
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            data-provider="flatpickr"
                            data-date-format="d M, Y"
                            data-range-date="true"
                            id="demo-datepicker"
                            placeholder="Select date"
                          />
                        </div>
                      </div>
                      {/*end col*/}
                      <div className="col-xxl-2 col-sm-4">
                        <div>
                          <select
                            className="form-control"
                            data-choices=""
                            data-choices-search-false=""
                            name="choices-single-default"
                            id="idStatus"
                          >
                            <option value="">Status</option>
                            <option value="all" selected="">
                              All
                            </option>
                            <option value="Pending">Pending</option>
                            <option value="Inprogress">Inprogress</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Pickups">Pickups</option>
                            <option value="Returns">Returns</option>
                            <option value="Delivered">Delivered</option>
                          </select>
                        </div>
                      </div>
                      {/*end col*/}
                      <div className="col-xxl-2 col-sm-4">
                        <div>
                          <select
                            className="form-control"
                            data-choices=""
                            data-choices-search-false=""
                            name="choices-single-default"
                            id="idPayment"
                          >
                            <option value="">Select Payment</option>
                            <option value="all" selected="">
                              All
                            </option>
                            <option value="Mastercard">Mastercard</option>
                            <option value="Paypal">Paypal</option>
                            <option value="Visa">Visa</option>
                            <option value="COD">COD</option>
                          </select>
                        </div>
                      </div>
                      {/*end col*/}
                      <div className="col-xxl-1 col-sm-4">
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary w-100"
                            onclick="SearchData();"
                          >
                            {" "}
                            <i className="ri-equalizer-fill me-1 align-bottom" />
                            Filters
                          </button>
                        </div>
                      </div>
                      {/*end col*/}
                    </div>
                    {/*end row*/}
                  </form>
                </div>
                <div className="card-body pt-2">
                  <div>
                   
                    <div className="table-responsive table-card mb-1">
                      <table
                        className="table table-nowrap align-middle"
                        id="orderTable"
                      >
                        <thead className="text-muted table-light">
                          <tr className="text-uppercase">
                            {/* <th scope="col" style={{ width: 25 }}>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="checkAll"
                                  defaultValue="option"
                                />
                              </div>
                            </th> */}
                      
                            <th className="sort" data-sort="customer_name">
                              User
                            </th>
                            <th className="sort" data-sort="product_name">
                              Phone
                            </th>
                            <th className="sort" data-sort="date">
                              Email
                            </th>
                            <th className="sort" data-sort="amount">
                              Registration Date
                            </th>
                            <th className="sort" data-sort="payment">
                           Status
                            </th>
                            {/* <th className="sort" data-sort="status">
                            Quick Actions
                            </th> */}
                            <th className="sort" data-sort="city">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                        



{registrations?
<>
{registrations.map((item,index)=>(
<>

<HackingInternshipRegistrationItem SelectUser={()=>SelectUser({id:item.id})} item={item}/>
</>
))}


</>:
<>


</>}



                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#405189,secondary:#0ab39c"
                            style={{ width: 75, height: 75 }}
                          />
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <a
                          className="page-item pagination-prev disabled"
                          href="#"
                        >
                          Previous
                        </a>
                        <ul className="pagination listjs-pagination mb-0" />
                        <a className="page-item pagination-next" href="#">
                          Next
                        </a>
                      </div>
                    </div>
                  </div>
              
                </div>
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}
        </div>

   </>
  )
}

export default HackingInternshipRegistrations